import React, { useEffect } from "react";
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import TaskRoundedIcon from '@mui/icons-material/TaskRounded';
import './dashboard.scss'
import AttendanceCalender from "../attendance/attendance";
import { useAppSelector, useAppDispatch } from "../../../store/hooks/hooks";
import { getProgress, getPlacementDetails, getAttendanceDetails, getUserDetailsAction, getTasks, getEvents } from "../../../store/StudentAction";


const StudentDashboard = () => {
    const userDetails = useAppSelector((state: any) => state.user.user.result)
    const progress = useAppSelector((state:any) => state.user.progress)
    const attendanceDetails = useAppSelector((state:any) => state.user.attendance)
    const dispatch = useAppDispatch()

    const fetchProgressDetails = async () => {
        await dispatch(getProgress())
    }
    const fetchPlacemetDetails = async () => {
        await dispatch(getPlacementDetails())
    }
    const fetchAttendanceDetails = async () => {
        await dispatch(getAttendanceDetails())
    }
    const fetchTaskDetails = async () => {
        await dispatch(getTasks())
    }
    const fetchEventList = async () => {
        await dispatch(getEvents("all"))
    }

    useEffect(() => {
        fetchProgressDetails()
        fetchPlacemetDetails()
        fetchAttendanceDetails()
        fetchTaskDetails()
        fetchEventList()
    }, [])
    return (
        <div>
            <div className="backGround-Continer p-5 flex w-100">
                <div className="flex flex-column justify-content-around">
                    <div>
                        <h1 className='title'>Welcome Back,{userDetails.first_name}</h1>
                        <h2 className='subTitle gray-color body-p'>Track,manage and forecast your placement details.</h2>
                    </div>
                    <div>
                        {
                            Object.keys(progress).length > 0 && <>
                                <h3 className="overViewTitle">Overview</h3>
                                <div className="flex flex-row wrap-mob">
                                    <div className="flex flex-row m-1">
                                        <div className="m-2 p-4 iconContainer">
                                            <AccessTimeRoundedIcon fontSize="medium" />
                                        </div>
                                        <div className="align-content-center flex flex-column justify-content-center">
                                            <p className="m-0 font-thin">Hours Spent</p>
                                            <span>
                                                {progress.Hours}<span className="font-thin">h</span>
                                            </span>
                                        </div>

                                    </div>
                                    <div className="flex flex-row m-1">
                                        <div className="m-2 p-4 iconContainer">
                                            <SchoolRoundedIcon fontSize="medium" />
                                        </div>
                                        <div className="align-content-center flex flex-column justify-content-center">
                                            <p className="m-0 font-thin">Progress</p>
                                            <span>
                                                {progress.Progress}<span className="font-thin">%</span>
                                            </span>
                                        </div>

                                    </div>
                                    <div className="flex flex-row m-1">
                                        <div className="m-2 p-4 iconContainer">
                                            <TaskRoundedIcon fontSize="medium" />
                                        </div>
                                        <div className="align-content-center flex flex-column justify-content-center">
                                            <p className="m-0 font-thin">Task Completed</p>
                                            <span>
                                                {progress.Task_Completed.split(",").length}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            </>
                        }

                    </div>
                </div>
                {
                    attendanceDetails && Object.keys(attendanceDetails).length > 0 && <AttendanceCalender data={attendanceDetails.attendance}></AttendanceCalender>
                }
            </div>

        </div>

    )

}
export default StudentDashboard